/** @jsx jsx */
import { jsx } from 'theme-ui'
import { motion } from 'framer-motion'

export const ReactIcon = ({ size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 6.57302C7.2135 6.57302 6.573 7.21352 6.573 8.00002C6.573 8.78652 7.2135 9.42702 8 9.42702C8.7865 9.42702 9.427 8.78652 9.427 8.00002C9.427 7.21352 8.7865 6.57302 8 6.57302ZM4.005 10.836L3.69 10.758C1.346 10.164 0 9.15902 0 7.99752C0 6.83602 1.3465 5.83102 3.69 5.23702L4.005 5.15902L4.0935 5.47152C4.33129 6.29003 4.63529 7.08783 5.0025 7.85702L5.07 7.99752L5.0025 8.14052C4.63452 8.90938 4.33049 9.70724 4.0935 10.526L4.005 10.836ZM3.5445 5.96602C1.763 6.46602 0.6695 7.23402 0.6695 7.99752C0.6695 8.76102 1.7635 9.52602 3.5445 10.029C3.76283 9.33534 4.02639 8.65672 4.3335 7.99752C4.02596 7.3385 3.76239 6.65985 3.5445 5.96602V5.96602ZM11.995 10.836L11.9065 10.5235C11.6691 9.70568 11.3651 8.90868 10.9975 8.14052L10.93 7.99752L10.9975 7.85452C11.3655 7.08566 11.6695 6.28779 11.9065 5.46902L11.995 5.15902L12.31 5.23702C14.654 5.83102 16 6.83602 16 7.99752C16 9.15902 14.6535 10.164 12.31 10.758L11.995 10.836ZM11.6665 7.99752C11.9746 8.65628 12.2382 9.33497 12.4555 10.029C14.2395 9.52652 15.3305 8.76102 15.3305 7.99752C15.3305 7.23402 14.2365 6.46902 12.4555 5.96602C12.2367 6.65952 11.9731 7.33811 11.6665 7.99752ZM3.539 5.96352L3.4505 5.65102C2.7915 3.32802 2.992 1.66152 4 1.08052C4.9895 0.510017 6.5755 1.18452 8.2395 2.89302L8.466 3.12502L8.2395 3.35702C7.64858 3.97183 7.10863 4.63368 6.625 5.33602L6.534 5.46352L6.3775 5.47652C5.52674 5.54367 4.68281 5.67961 3.854 5.88302L3.539 5.96352ZM4.8045 1.54452C4.625 1.54452 4.466 1.58102 4.333 1.65902C3.6715 2.04202 3.5545 3.37002 4.01 5.16152C4.72072 5.00253 5.4411 4.89029 6.1665 4.82552C6.58413 4.23071 7.0408 3.6643 7.5335 3.13002C6.4945 2.11702 5.51 1.54402 4.8045 1.54402V1.54452ZM11.198 15.117C11.1955 15.117 11.1955 15.117 11.198 15.117C10.2475 15.117 9.026 14.4035 7.7605 13.1015L7.534 12.8695L7.7605 12.6375C8.35142 12.0227 8.89137 11.3609 9.375 10.6585L9.4635 10.531L9.62 10.5155C10.4719 10.4506 11.3168 10.3146 12.146 10.109L12.461 10.031L12.5495 10.3435C13.2085 12.6665 13.008 14.3305 12 14.911C11.7563 15.0511 11.479 15.1221 11.198 15.1165V15.117ZM8.466 12.8645C9.505 13.8775 10.4895 14.4505 11.195 14.4505H11.1975C11.3745 14.4505 11.5335 14.4115 11.6665 14.336C12.328 13.953 12.448 12.625 11.9895 10.8335C11.2789 10.9927 10.5585 11.1041 9.833 11.167C9.41539 11.7626 8.95872 12.3299 8.466 12.865V12.8645ZM12.461 5.96352L12.146 5.88302C11.3162 5.68029 10.4715 5.54436 9.62 5.47652L9.4635 5.46352L9.375 5.33602C8.89137 4.63368 8.35142 3.97183 7.7605 3.35702L7.534 3.12502L7.7605 2.89302C9.4245 1.18452 11.0105 0.510017 12 1.08052C13.008 1.66102 13.2085 3.32802 12.5495 5.65102L12.461 5.96352ZM9.8335 4.82552C10.5589 4.89012 11.2793 5.00236 11.99 5.16152C12.4485 3.37002 12.3285 2.04152 11.667 1.65902C11.008 1.27902 9.7685 1.86202 8.4665 3.13052C8.95787 3.66594 9.41447 4.23227 9.8335 4.82602V4.82552ZM4.8045 15.117C4.523 15.122 4.2445 15.052 4 14.9115C2.992 14.331 2.7915 12.6665 3.4505 10.344L3.539 10.0315L3.854 10.1095C4.625 10.305 5.474 10.44 6.3775 10.516L6.534 10.5315L6.6225 10.659C7.10613 11.3614 7.64608 12.0232 8.237 12.638L8.4635 12.87L8.237 13.102C6.974 14.404 5.7525 15.1175 4.8045 15.1175V15.117ZM4.0105 10.8335C3.552 12.625 3.672 13.9535 4.3335 14.336C4.9925 14.711 6.2295 14.133 7.534 12.8645C7.04128 12.3294 6.58461 11.7621 6.167 11.1665C5.44151 11.1038 4.72105 10.9924 4.0105 10.833V10.8335ZM8 11.2525C7.4505 11.2525 6.888 11.229 6.323 11.182L6.1665 11.169L6.0755 11.039C5.75636 10.5805 5.45659 10.1087 5.177 9.62502C4.89683 9.1413 4.6371 8.64603 4.3985 8.14052L4.331 7.99752L4.3985 7.85452C4.87651 6.84371 5.43743 5.87422 6.0755 4.95602L6.1665 4.82602L6.323 4.81302C7.43902 4.71902 8.56098 4.71902 9.677 4.81302L9.8335 4.82602L9.9245 4.95602C10.5634 5.8737 11.1243 6.84325 11.6015 7.85452L11.669 7.99752L11.6015 8.14052C11.1253 9.15228 10.5643 10.1219 9.9245 11.039L9.8335 11.169L9.677 11.182C9.11922 11.2287 8.55973 11.2522 8 11.2525V11.2525ZM6.5365 10.5285C7.521 10.604 8.479 10.604 9.466 10.5285C10.0165 9.72247 10.5057 8.87626 10.9295 7.99702C10.5075 7.11632 10.0173 6.26992 9.4635 5.46552C8.48929 5.39002 7.51071 5.39002 6.5365 5.46552C5.98231 6.26967 5.49213 7.1161 5.0705 7.99702C5.49446 8.8767 5.98453 9.72296 6.5365 10.5285V10.5285Z"
      fill="black"
    />
  </svg>
)

export const SwiftIcon = ({ size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M14.6565 10.8985C14.693 10.8225 14.693 10.75 14.7325 10.6745C15.628 7.15851 13.498 3.0465 9.834 0.880005C11.4405 3.0465 12.076 5.6275 11.516 7.9455C11.4717 8.15025 11.4089 8.35057 11.3285 8.544C11.2257 8.48632 11.1258 8.42375 11.029 8.3565C11.029 8.3565 7.4035 6.1145 3.5155 2.187C3.4035 2.075 5.6095 5.3275 8.0755 7.9085C6.917 7.2345 3.6275 4.88 1.57 2.974C1.794 3.3825 2.1325 3.794 2.4685 4.206C4.187 6.4115 6.432 9.104 9.1225 11.1585C7.216 12.32 4.5625 12.393 1.87 11.1585C1.198 10.862 0.6355 10.4865 0 10.039C1.1225 11.7965 2.88 13.403 4.974 14.263C7.4795 15.3485 10.0205 15.273 11.8515 14.263H11.891C11.9635 14.2265 12.0395 14.187 12.115 14.1145C13.011 13.664 14.7685 13.18 15.7395 15.049C16.003 15.5725 16.487 13.143 14.656 10.8985H14.6565Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const GraphqlIcon = ({ size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip1)">
      <path
        d="M9.36819 1.83348L12.6572 3.73448C12.8102 3.57364 12.9986 3.4506 13.2074 3.3751C13.4162 3.2996 13.6397 3.2737 13.8602 3.29945C14.0808 3.32521 14.2923 3.40191 14.4781 3.52349C14.6639 3.64507 14.8188 3.8082 14.9307 3.99998C15.0412 4.19248 15.1055 4.40809 15.1182 4.62971C15.131 4.85133 15.092 5.07289 15.0043 5.27681C14.9165 5.48074 14.7825 5.66143 14.6128 5.80457C14.4432 5.94771 14.2425 6.04936 14.0267 6.10148V9.90098C14.2429 9.952 14.444 10.053 14.6141 10.1958C14.7842 10.3387 14.9184 10.5194 15.006 10.7235C15.0937 10.9276 15.1322 11.1494 15.1186 11.371C15.105 11.5927 15.0396 11.8081 14.9277 12C14.8145 12.1953 14.6567 12.3611 14.4672 12.4837C14.2776 12.6064 14.0617 12.6823 13.8371 12.7055C13.6125 12.7286 13.3857 12.6982 13.1751 12.6168C12.9646 12.5353 12.7763 12.4052 12.6257 12.237L9.35469 14.125C9.42557 14.3394 9.44458 14.5675 9.41014 14.7906C9.3757 15.0138 9.2888 15.2256 9.15658 15.4086C9.02436 15.5916 8.85059 15.7407 8.64956 15.8435C8.44853 15.9463 8.22598 15.9999 8.00019 16C7.77826 16.0001 7.55936 15.9485 7.36093 15.8491C7.1625 15.7497 6.99003 15.6053 6.85726 15.4275C6.72449 15.2496 6.63509 15.0433 6.59619 14.8248C6.55729 14.6063 6.56996 14.3817 6.63319 14.169L3.34169 12.2705C3.21243 12.4063 3.05763 12.5154 2.88616 12.5913C2.71469 12.6672 2.52992 12.7085 2.34244 12.7129C2.15497 12.7173 1.96848 12.6846 1.79366 12.6167C1.61884 12.5489 1.45913 12.4472 1.32369 12.3175C1.13918 12.1401 1.00569 11.9164 0.937152 11.6698C0.868615 11.4232 0.86755 11.1627 0.934066 10.9155C1.00058 10.6684 1.13224 10.4436 1.31529 10.2647C1.49834 10.0858 1.72607 9.95932 1.97469 9.89848V6.09898C1.7754 6.05154 1.58867 5.96172 1.42721 5.83563C1.26576 5.70954 1.13336 5.55015 1.03904 5.36829C0.944722 5.18644 0.890691 4.9864 0.880628 4.78179C0.870565 4.57718 0.904705 4.3728 0.980724 4.18257C1.05674 3.99234 1.17286 3.82072 1.32116 3.6794C1.46947 3.53808 1.64648 3.43037 1.84015 3.3636C2.03383 3.29684 2.23961 3.27258 2.4435 3.29249C2.64739 3.3124 2.84459 3.37601 3.02169 3.47898C3.13869 3.54648 3.24819 3.62998 3.34219 3.72898L6.63369 1.83048C6.52634 1.46819 6.56727 1.07811 6.74748 0.745995C6.9277 0.413884 7.23244 0.166945 7.59469 0.0594801C7.841 -0.0141688 8.10265 -0.0198103 8.35191 0.0431532C8.60117 0.106117 8.82875 0.23534 9.01054 0.417129C9.19233 0.598917 9.32155 0.8265 9.38451 1.07576C9.44748 1.32502 9.44184 1.58667 9.36819 1.83298V1.83348ZM9.02469 2.41948C9.01169 2.43248 9.00119 2.44548 8.98569 2.45848L13.2932 9.91698C13.3112 9.91198 13.3322 9.90648 13.3477 9.90148V6.09698C13.1663 6.05212 12.9955 5.9719 12.8451 5.8609C12.6948 5.74991 12.5678 5.61033 12.4715 5.45016C12.3752 5.29 12.3115 5.1124 12.284 4.92755C12.2565 4.74271 12.2657 4.55425 12.3112 4.37298C12.3137 4.35748 12.3192 4.33898 12.3217 4.32348L9.02469 2.41948ZM7.01419 2.45848L6.97519 2.41948L3.67819 4.32048C3.7826 4.68343 3.73867 5.07298 3.55604 5.40355C3.37341 5.73412 3.06702 5.97867 2.70419 6.08348L2.65219 6.09648V9.90098L2.70969 9.91648L7.01719 2.45798L7.01419 2.45848ZM8.39969 2.79698C8.13989 2.86998 7.86499 2.86998 7.60519 2.79698L3.29769 10.2555C3.49319 10.443 3.63119 10.685 3.69869 10.951H12.3057C12.3707 10.6855 12.5087 10.443 12.7067 10.253L8.39969 2.79698ZM9.05569 13.6145L12.3317 11.7215C12.3212 11.69 12.3137 11.659 12.3057 11.6275H3.69619L3.68069 11.682L6.97519 13.583C7.10803 13.445 7.26741 13.3354 7.44373 13.2606C7.62005 13.1859 7.80967 13.1476 8.00119 13.148C8.42069 13.148 8.79569 13.3275 9.05569 13.614V13.6145Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip1">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const ScalaIcon = ({ size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.05859 16C6.08209 16 12.2641 14.9895 12.9386 14V10.1795C12.3006 11.1195 6.08159 12.122 3.05859 12.122V16ZM3.05859 10.909C6.08209 10.909 12.2641 9.8985 12.9386 8.909V5.0915C12.3006 6.029 6.08159 7.0315 3.05859 7.0315V10.909ZM3.05859 5.8205C6.08209 5.8205 12.2641 4.81 12.9386 3.8205V0C12.3006 0.9375 6.08159 1.94 3.05859 1.94V5.8205Z"
      fill="black"
    />
  </svg>
)

export const RubyIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4375 0.0544502C15.459 0.40595 16.034 1.78645 15.9895 3.23445L16 3.21295L15.0915 15.1405L3.271 15.9504C2.2895 15.9084 0.099 15.82 0.0005 12.7605L1.097 10.7605L2.977 15.151L3.313 15.9315L5.1825 9.83545L5.162 9.84095L5.1725 9.81945L11.342 11.7915L10.412 8.16895L9.7535 5.56945L15.631 5.18945L15.2225 4.85095L11.001 1.40845L13.441 0.0489502L13.4375 0.0544502ZM0 12.7264V12.742V12.724V12.7264ZM3.4195 3.38245C5.794 1.02595 8.857 -0.36505 10.034 0.82245C11.208 2.00795 9.9635 4.89295 7.586 7.24445C5.2105 9.60095 2.1845 11.068 1.0105 9.88245C-0.167 8.70045 1.039 5.73895 3.419 3.38245H3.4195Z"
      fill="black"
    />
  </svg>
)

export const CodeIcon = () => (
  <svg
    width="387"
    height="202"
    viewBox="0 0 387 202"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="387" height="202" rx="10" fill="#0E354A" />
    <rect x="154" y="156" width="40" height="8" rx="4" fill="#FDB05D" />
    <rect x="61" y="156" width="87" height="8" rx="4" fill="#31CC8A" />
    <rect x="26" y="156" width="30" height="8" rx="4" fill="#FD95EE" />
    <rect x="26" y="141" width="208" height="8" rx="4" fill="#8BA1AE" />
    <rect x="123" y="99" width="117" height="8" rx="4" fill="#FD95EE" />
    <rect x="90" y="99" width="28" height="8" rx="4" fill="#FDB05D" />
    <rect x="61" y="99" width="23" height="8" rx="4" fill="#31CC8A" />
    <rect x="26" y="99" width="30" height="8" rx="4" fill="#FD95EE" />
    <rect x="26" y="84" width="203" height="8" rx="4" fill="#8BA1AE" />
    <rect x="173" y="46" width="117" height="8" rx="4" fill="#FD95EE" />
    <rect x="118" y="46" width="50" height="8" rx="4" fill="#FDB05D" />
    <rect x="61" y="46" width="52" height="8" rx="4" fill="#31CC8A" />
    <rect x="26" y="46" width="30" height="8" rx="4" fill="#FD95EE" />
    <rect x="26" y="31" width="124" height="8" rx="4" fill="#8BA1AE" />
  </svg>
)

export const BitmaticaIcon = () => (
  <svg
    width="40"
    height="55"
    viewBox="0 0 90 105"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.8909 45.8747V46.4603L29.8753 45.8747H0V60.5C0 85.0347 20.1896 105 45 105C69.8104 105 90 85.0347 90 60.5C90 35.9653 69.8104 16 45 16H29.8909V45.8747ZM59.9455 75.7494H30.0545V45.8747H59.9455V75.7494Z"
      fill="currentColor"
    />
    <path d="M0 0V15.0026V45L29 15.0026V0H0Z" fill="currentColor" />
  </svg>
)

export const BitmaticaLogo = () => (
  <svg
    width="190"
    height="44"
    viewBox="0 0 190 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6206 19.4198V19.6633L12.614 19.4198H0V25.5C0 35.6998 8.5245 44 19 44C29.4755 44 38 35.6998 38 25.5C38 15.3002 29.4755 7 19 7H12.6206V19.4198ZM25.3103 31.8397H12.6897V19.4198H25.3103V31.8397Z"
      fill="currentColor"
    />
    <path d="M0 0V6.33442V19L12 6.33442V0H0Z" fill="currentColor" />
    <path
      d="M52.4258 12.0408H60.4939C64.5595 12.0408 67.4905 14.2527 67.4905 18.0129C67.4905 19.972 66.5135 21.5203 64.9062 22.3419C67.4275 23.2267 68.8142 25.1226 68.8142 27.682C68.8142 31.7267 65.7887 34.1597 60.9667 34.1597H52.4258V12.0408ZM60.0212 20.8568C61.66 20.8568 62.8576 20.0036 62.8576 18.4237C62.8576 16.8122 61.66 15.9906 60.0212 15.9906H57.0587V20.8568H60.0212V20.8568ZM60.683 30.1783C62.7001 30.1783 64.0237 29.2304 64.0237 27.4293C64.0237 25.6597 62.6686 24.6802 60.683 24.6802H57.0587V30.1783H60.683Z"
      fill="white"
    />
    <path d="M71.7148 34.1597V18.55H76.3162V34.1597H71.7148Z" fill="white" />
    <path
      d="M85.2955 13.9683V18.55H89.235V22.3419H85.2955V28.0612C85.2955 29.7359 86.0204 30.3995 87.5332 30.3995C88.1005 30.3995 88.7308 30.2415 89.235 29.9255V33.9069C88.5417 34.2545 87.5017 34.5389 86.0204 34.5389C82.7427 34.5389 80.7257 32.5166 80.7257 29.0408V22.3419H78.5195V18.55H80.7257V13.9683H85.2955Z"
      fill="white"
    />
    <path
      d="M96.3279 34.1596H91.7266V18.5499H96.3279V20.5091C97.1473 19.0871 98.6601 18.1392 100.709 18.1392C102.82 18.1392 104.428 19.1503 105.279 20.8566C106.256 19.2135 108.02 18.1392 110.29 18.1392C113.851 18.1392 115.868 20.5722 115.868 24.3641V34.1596H111.267V25.4384C111.267 23.5109 110.384 22.3418 108.777 22.3418C107.201 22.3418 106.129 23.6373 106.098 25.7228V34.1596H101.497V25.5016C101.497 23.5109 100.614 22.3418 99.0383 22.3418C97.3995 22.3418 96.3279 23.6689 96.3279 25.8176V34.1596V34.1596Z"
      fill="white"
    />
    <path
      d="M135.44 18.5501V34.1598H130.933V32.0743C129.861 33.6542 127.939 34.5389 125.89 34.5389C121.699 34.5389 118.516 30.9999 118.516 26.3549C118.516 21.7415 121.699 18.1709 125.89 18.1709C127.939 18.1709 129.861 18.9609 130.933 20.5724V18.5501H135.44V18.5501ZM127.088 30.3995C129.326 30.3995 131.091 28.5984 131.091 26.3549C131.091 24.1114 129.326 22.3103 127.088 22.3103C124.85 22.3103 123.085 24.1114 123.085 26.3549C123.085 28.5984 124.85 30.3995 127.088 30.3995Z"
      fill="white"
    />
    <path
      d="M144.452 13.9683V18.55H148.391V22.3419H144.452V28.0612C144.452 29.7359 145.177 30.3995 146.689 30.3995C147.257 30.3995 147.887 30.2415 148.391 29.9255V33.9069C147.698 34.2545 146.658 34.5389 145.177 34.5389C141.899 34.5389 139.882 32.5166 139.882 29.0408V22.3419H137.676V18.55H139.882V13.9683H144.452Z"
      fill="white"
    />
    <path d="M151.133 34.1597V18.55H155.734V34.1597H151.133Z" fill="white" />
    <path
      d="M166.859 18.1392C168.215 18.1392 169.633 18.4551 170.767 19.1187V23.4477C169.696 22.6893 168.593 22.3102 167.395 22.3102C165 22.3102 163.172 23.9849 163.172 26.3548C163.172 28.6931 164.968 30.3994 167.395 30.3994C168.624 30.3994 169.822 29.8938 170.799 29.1986V33.5592C169.538 34.2544 168.152 34.5704 166.796 34.5704C162.006 34.5704 158.539 31.2525 158.539 26.3548C158.539 21.6466 161.974 18.1392 166.859 18.1392Z"
      fill="white"
    />
    <path
      d="M189.705 18.5501V34.1598H185.199V32.0743C184.127 33.6542 182.205 34.5389 180.156 34.5389C175.964 34.5389 172.781 30.9999 172.781 26.3549C172.781 21.7415 175.964 18.1709 180.156 18.1709C182.205 18.1709 184.127 18.9609 185.199 20.5724V18.5501H189.705V18.5501ZM181.354 30.3995C183.591 30.3995 185.356 28.5984 185.356 26.3549C185.356 24.1114 183.591 22.3103 181.354 22.3103C179.116 22.3103 177.351 24.1114 177.351 26.3549C177.351 28.5984 179.116 30.3995 181.354 30.3995Z"
      fill="white"
    />
    <path d="M156 12H151V16H156V12Z" fill="white" />
    <path d="M76 12H72V16H76V12Z" fill="white" />
  </svg>
)

export const ArrowIcon = () => (
  <svg
    width="27"
    height="16"
    viewBox="0 0 31 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3454 18.0001L29.3457 9.99979L21.3454 1.99951"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.3462 9.99994L1.65234 9.99994"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

// Service Icons

export const ServiceDesignIcon = ({ fill = 'currentColor' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.75 11.75H20.25V5.25C20.25 4.975 20.025 4.75 19.75 4.75H5.25C4.975 4.75 4.75 4.975 4.75 5.25V19.75C4.75 20.025 4.975 20.25 5.25 20.25H11.75V26.75C11.75 27.025 11.975 27.25 12.25 27.25H26.75C27.025 27.25 27.25 27.025 27.25 26.75V12.25C27.25 11.975 27.025 11.75 26.75 11.75ZM11.75 12.25V18.125H6.875V6.875H18.125V11.75H12.25C11.975 11.75 11.75 11.975 11.75 12.25ZM18.125 13.875V18.125H13.875V13.875H18.125ZM25.125 25.125H13.875V20.25H19.75C20.025 20.25 20.25 20.025 20.25 19.75V13.875H25.125V25.125Z"
      fill={fill}
    />
  </svg>
)

export const ServiceDevIcon = ({ fill = 'currentColor' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.125 21.0312C16.125 21.1688 16.2313 21.2812 16.3594 21.2812H22.1406C22.2687 21.2812 22.375 21.1688 22.375 21.0312V19.5312C22.375 19.3937 22.2687 19.2812 22.1406 19.2812H16.3594C16.2313 19.2812 16.125 19.3937 16.125 19.5312V21.0312ZM10.0344 21.2219L16.0344 16.1906C16.1531 16.0906 16.1531 15.9062 16.0344 15.8062L10.0344 10.7781C9.99815 10.7473 9.95386 10.7276 9.90674 10.7212C9.85962 10.7148 9.81166 10.7221 9.76856 10.7422C9.72546 10.7622 9.68902 10.7943 9.66357 10.8344C9.63813 10.8746 9.62474 10.9212 9.625 10.9688V12.9281C9.625 13.0031 9.65625 13.0719 9.71562 13.1187L13.1469 16L9.71562 18.8813C9.68769 18.9046 9.66514 18.9338 9.6495 18.9667C9.63385 18.9996 9.6255 19.0355 9.625 19.0719V21.0312C9.625 21.2438 9.87188 21.3594 10.0344 21.2219ZM27.5 3.5H4.5C3.94687 3.5 3.5 3.94687 3.5 4.5V27.5C3.5 28.0531 3.94687 28.5 4.5 28.5H27.5C28.0531 28.5 28.5 28.0531 28.5 27.5V4.5C28.5 3.94687 28.0531 3.5 27.5 3.5ZM26.25 26.25H5.75V5.75H26.25V26.25Z"
      fill={fill}
    />
  </svg>
)

export const ServiceStrategyIcon = ({ fill = 'currentColor' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.447 12.2531L19.747 4.55312C19.5439 4.35 19.2783 4.25 19.0126 4.25C18.747 4.25 18.4814 4.35 18.2783 4.55312L13.2439 9.59062C12.8626 9.54687 12.4783 9.52812 12.0939 9.52812C9.80639 9.52812 7.51889 10.2813 5.64077 11.7875C5.52704 11.8788 5.43382 11.9931 5.36719 12.1228C5.30055 12.2526 5.262 12.3949 5.25404 12.5405C5.24608 12.6862 5.26889 12.8319 5.32099 12.9681C5.37308 13.1043 5.45329 13.2281 5.55639 13.3313L11.2345 19.0094L4.50327 25.7344C4.42078 25.8163 4.36988 25.9248 4.35952 26.0406L4.25327 27.2031C4.22514 27.4969 4.45952 27.7469 4.75014 27.7469C4.76577 27.7469 4.78139 27.7469 4.79702 27.7437L5.95952 27.6375C6.07514 27.6281 6.18452 27.575 6.26577 27.4937L12.997 20.7625L18.6751 26.4406C18.8783 26.6437 19.1439 26.7437 19.4095 26.7437C19.7126 26.7437 20.0126 26.6125 20.2189 26.3563C21.9783 24.1594 22.7095 21.4094 22.4126 18.75L27.447 13.7156C27.8501 13.3156 27.8501 12.6594 27.447 12.2531V12.2531ZM20.8189 17.1656L20.0533 17.9312L20.172 19.0063C20.3582 20.669 20.0265 22.3486 19.222 23.8156L8.18764 12.775C8.59077 12.5531 9.00952 12.3656 9.44702 12.2156C10.297 11.9219 11.1876 11.775 12.0939 11.775C12.3939 11.775 12.697 11.7906 12.997 11.825L14.072 11.9438L14.8376 11.1781L19.0158 7L25.0001 12.9844L20.8189 17.1656Z"
      fill={fill}
    />
  </svg>
)

export const ServiceTeamIcon = ({ fill = 'currentColor' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.7558 21.8716C24.9737 21.0888 24.0597 20.4499 23.0558 19.9841C24.4715 18.8373 25.3746 17.0873 25.3746 15.1248C25.3746 11.6623 22.4871 8.82163 19.0246 8.87476C15.6152 8.92788 12.8683 11.706 12.8683 15.1248C12.8683 17.0873 13.7746 18.8373 15.1871 19.9841C14.183 20.4495 13.269 21.0885 12.4871 21.8716C10.7808 23.581 9.81209 25.8373 9.74959 28.2435C9.74876 28.2769 9.75461 28.31 9.7668 28.3411C9.77899 28.3722 9.79727 28.4005 9.82057 28.4243C9.84387 28.4482 9.87171 28.4672 9.90245 28.4801C9.9332 28.4931 9.96623 28.4998 9.99959 28.4998H11.7496C11.884 28.4998 11.9965 28.3935 11.9996 28.2591C12.059 26.4466 12.7933 24.7498 14.084 23.4623C14.7444 22.7983 15.53 22.2719 16.3952 21.9136C17.2604 21.5553 18.1881 21.3721 19.1246 21.3748C21.0277 21.3748 22.8183 22.1154 24.1652 23.4623C25.4527 24.7498 26.1871 26.4466 26.2496 28.2591C26.2527 28.3935 26.3652 28.4998 26.4996 28.4998H28.2496C28.283 28.4998 28.316 28.4931 28.3467 28.4801C28.3775 28.4672 28.4053 28.4482 28.4286 28.4243C28.4519 28.4005 28.4702 28.3722 28.4824 28.3411C28.4946 28.31 28.5004 28.2769 28.4996 28.2435C28.4371 25.8373 27.4683 23.581 25.7558 21.8716ZM19.1246 19.1248C18.0558 19.1248 17.0496 18.7091 16.2965 17.9529C15.9185 17.5779 15.62 17.1306 15.4186 16.6378C15.2173 16.1449 15.1173 15.6165 15.1246 15.0841C15.134 14.0591 15.5433 13.0685 16.259 12.3341C17.009 11.5654 18.0121 11.1373 19.084 11.1248C20.1433 11.1154 21.1715 11.5279 21.9277 12.2685C22.7027 13.0279 23.1277 14.0435 23.1277 15.1248C23.1277 16.1935 22.7121 17.1966 21.9558 17.9529C21.5848 18.3257 21.1436 18.6212 20.6576 18.8224C20.1716 19.0235 19.6506 19.1263 19.1246 19.1248ZM11.2965 15.9498C11.2683 15.6779 11.2527 15.4029 11.2527 15.1248C11.2527 14.6279 11.2996 14.1435 11.3871 13.6716C11.409 13.5591 11.3496 13.4435 11.2465 13.3966C10.8215 13.206 10.4308 12.9435 10.0933 12.6123C9.69565 12.2267 9.38271 11.7624 9.17448 11.2491C8.96625 10.7358 8.86731 10.1847 8.88397 9.63101C8.91209 8.62788 9.31522 7.67476 10.0183 6.95601C10.7902 6.16538 11.8277 5.73413 12.9308 5.74663C13.9277 5.75601 14.8902 6.14038 15.6183 6.82163C15.8652 7.05288 16.0777 7.30913 16.2558 7.58413C16.3183 7.68101 16.4402 7.72163 16.5465 7.68413C17.0965 7.49351 17.6777 7.35913 18.2746 7.29663C18.4496 7.27788 18.5496 7.09038 18.4715 6.93413C17.4558 4.92476 15.3808 3.53726 12.9808 3.49976C9.51522 3.44663 6.62772 6.28726 6.62772 9.74663C6.62772 11.7091 7.53084 13.4591 8.94647 14.606C7.95272 15.0654 7.03709 15.6998 6.24334 16.4935C4.53084 18.2029 3.56209 20.4591 3.49959 22.8685C3.49876 22.9019 3.50461 22.935 3.5168 22.9661C3.52899 22.9972 3.54727 23.0255 3.57057 23.0493C3.59386 23.0732 3.62171 23.0922 3.65245 23.1051C3.6832 23.1181 3.71623 23.1248 3.74959 23.1248H5.50272C5.63709 23.1248 5.74959 23.0185 5.75272 22.8841C5.81209 21.0716 6.54647 19.3748 7.83709 18.0873C8.75584 17.1685 9.88084 16.531 11.109 16.2216C11.2308 16.1904 11.3121 16.0748 11.2965 15.9498V15.9498Z"
      fill={fill}
    />
  </svg>
)

export const ServiceProductIcon = ({ fill = 'currentColor' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 4.5H5C4.725 4.5 4.5 4.725 4.5 5V14.5C4.5 14.775 4.725 15 5 15H14.5C14.775 15 15 14.775 15 14.5V5C15 4.725 14.775 4.5 14.5 4.5ZM12.875 12.875H6.625V6.625H12.875V12.875ZM27 4.5H17.5C17.225 4.5 17 4.725 17 5V14.5C17 14.775 17.225 15 17.5 15H27C27.275 15 27.5 14.775 27.5 14.5V5C27.5 4.725 27.275 4.5 27 4.5ZM25.375 12.875H19.125V6.625H25.375V12.875ZM14.5 17H5C4.725 17 4.5 17.225 4.5 17.5V27C4.5 27.275 4.725 27.5 5 27.5H14.5C14.775 27.5 15 27.275 15 27V17.5C15 17.225 14.775 17 14.5 17ZM12.875 25.375H6.625V19.125H12.875V25.375ZM27 17H17.5C17.225 17 17 17.225 17 17.5V27C17 27.275 17.225 27.5 17.5 27.5H27C27.275 27.5 27.5 27.275 27.5 27V17.5C27.5 17.225 27.275 17 27 17ZM25.375 25.375H19.125V19.125H25.375V25.375Z"
      fill={fill}
    />
  </svg>
)

export const CheckCircleIcon = ({ size = '24', fill = '#FF0A8E' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM11.0234 5.71406L7.73281 10.2766C7.68682 10.3408 7.62619 10.3931 7.55595 10.4291C7.48571 10.4652 7.40787 10.4841 7.32891 10.4841C7.24994 10.4841 7.17211 10.4652 7.10186 10.4291C7.03162 10.3931 6.97099 10.3408 6.925 10.2766L4.97656 7.57656C4.91719 7.49375 4.97656 7.37813 5.07812 7.37813H5.81094C5.97031 7.37813 6.12187 7.45469 6.21562 7.58594L7.32812 9.12969L9.78438 5.72344C9.87813 5.59375 10.0281 5.51562 10.1891 5.51562H10.9219C11.0234 5.51562 11.0828 5.63125 11.0234 5.71406V5.71406Z"
      fill={fill}
    />
  </svg>
)

export const CKIcon = () => (
  <svg
    width="100%"
    viewBox="0 0 122 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.518 39.483C21.843 39.483 13.472 47.83 13.472 63.898C13.472 80.123 22.547 88.449 34.707 88.449C43.235 88.449 52.33 84.175 55.152 82.241V95.041C52.565 96.379 43.707 99.941 32.58 99.941C14.052 99.941 0 87.058 0 64.043C0 40.448 15.467 28 34.002 28C49.898 28 55.298 32.955 55.298 37.526C55.298 40.259 54.034 42.875 52.455 44.375C50.445 43.086 44.131 39.483 34.518 39.483Z"
      fill="white"
    ></path>
    <path
      d="M120.959 28.7261C115.685 42.4461 108.281 53.6861 99.9224 63.0671L121.086 98.2981L121.077 98.3031C120.345 98.697 118.399 99.7441 115.115 99.7441C109.256 99.7441 105.345 97.1641 102.407 92.2161L90.6464 72.3231C85.8374 76.7501 81.3694 80.3501 76.4054 83.8841V98.2981H63.5234V0.631104H76.4054V68.8171C90.1134 57.7181 101.46 44.3221 109.054 24.3741L120.959 28.7261Z"
      fill="white"
    ></path>
  </svg>
)

export const NitroIcon = () => (
  <svg
    width="135"
    height="184"
    viewBox="0 0 135 184"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M124.52 14L75.6596 1.00001C75.3596 0.920014 75.0696 0.870015 74.7796 0.810015L74.4496 0.740014L73.8596 0.670014C72.6122 0.508993 71.345 0.61119 70.1396 0.970015C66.6796 2.07001 64.6896 5.47001 65.3396 10.13L67.4096 25L72.7796 63.7L72.4796 63.33L72.4096 63.24L50.2396 39.46L50.1196 39.33C49.6776 38.7482 49.0896 38.2937 48.4151 38.0127C47.7407 37.7317 47.0039 37.6341 46.2796 37.73C44.3904 38.0843 42.6752 39.0634 41.4096 40.51L21.7096 60.28C16.8796 65.13 12.1196 74.64 11.1296 81.42L0.489556 154.42C0.0831565 157.799 0.889372 161.213 2.76462 164.053C4.63987 166.894 7.4624 168.976 10.7296 169.93L59.5896 182.93C60.725 183.243 61.9029 183.375 63.0796 183.32C67.7596 183.05 70.6796 179.32 69.9096 173.79L62.4796 120.2L62.7796 120.57L62.8496 120.66L84.9996 144.4L85.1096 144.53C87.1096 146.99 90.4496 146.75 93.8196 143.36L113.52 123.59C118.35 118.74 123.12 109.23 124.1 102.45L134.75 29.45C135.143 26.0814 134.332 22.6821 132.46 19.8542C130.588 17.0263 127.775 14.9525 124.52 14V14ZM80.9196 123.42L80.8296 123.32L61.7496 106.23L60.3596 104.84L59.8596 101.25L54.1596 60.25L54.4296 60.53L73.5096 77.63L74.8996 79L75.3996 82.59L81.0896 123.59L80.9196 123.42Z"
      fill="white"
    />
  </svg>
)

export const KwicrIcon = () => (
  <svg
    width="100%"
    viewBox="0 0 81 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3597 51.3523L62.5 26L35.0167 65.3295C33.4029 68.6844 29.9719 71 26 71C20.4772 71 16 66.5228 16 61C16 56.3911 19.118 52.5104 23.3597 51.3523Z"
      fill="#F58D2C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 0C17.9086 0 0 17.9086 0 40V42C0 50.6728 2.76016 58.7009 7.44997 65.2539C5.87701 61.8281 5 58.0165 5 54C5 39.0883 17.0883 27 32 27C38.1353 27 43.7926 29.0464 48.3267 32.4938L71.0019 17.8064L55.2767 40.3097C56.0328 41.5924 56.6859 42.9431 57.2245 44.3503L80.4334 28.8777C75.6149 12.1978 60.2319 0 42 0H40Z"
      fill="#F58D2C"
    />
  </svg>
)

export const ProductStrategyIllustration = ({ inView, styles }) => {
  return (
    <div sx={{ ...styles }}>
      <motion.svg
        initial={{ opacity: 0, y: 50 }}
        animate={inView && { opacity: 1, y: 0 }}
        width="349"
        height="425"
        viewBox="0 0 349 425"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="81.674" cy="2.97141" r="2.01389" fill="#170B32" />
        <circle cx="99.8381" cy="2.97141" r="2.01389" fill="#170B32" />
        <circle cx="117.998" cy="2.97141" r="2.01389" fill="#170B32" />
        <circle cx="136.166" cy="2.97141" r="2.01389" fill="#170B32" />
        <circle cx="154.326" cy="2.97141" r="2.01389" fill="#170B32" />
        <circle cx="172.49" cy="2.97141" r="2.01389" fill="#170B32" />
        <circle cx="190.655" cy="2.97141" r="2.01389" fill="#170B32" />
        <circle cx="208.819" cy="2.97141" r="2.01389" fill="#170B32" />
        <ellipse
          cx="226.983"
          cy="3.22314"
          rx="2.01389"
          ry="2.26562"
          fill="#170B32"
        />
        <circle cx="81.674" cy="23.5027" r="2.01389" fill="#170B32" />
        <circle cx="99.8381" cy="23.5027" r="2.01389" fill="#170B32" />
        <circle cx="117.998" cy="23.5027" r="2.01389" fill="#170B32" />
        <circle cx="136.166" cy="23.5027" r="2.01389" fill="#170B32" />
        <circle cx="154.326" cy="23.5027" r="2.01389" fill="#170B32" />
        <circle cx="172.49" cy="23.5027" r="2.01389" fill="#170B32" />
        <circle cx="190.655" cy="23.5027" r="2.01389" fill="#170B32" />
        <circle cx="208.819" cy="23.5027" r="2.01389" fill="#170B32" />
        <ellipse
          cx="226.983"
          cy="23.7544"
          rx="2.01389"
          ry="2.26562"
          fill="#170B32"
        />
        <circle cx="81.674" cy="44.0339" r="2.01389" fill="#170B32" />
        <circle cx="99.8381" cy="44.0339" r="2.01389" fill="#170B32" />
        <circle cx="117.998" cy="44.0339" r="2.01389" fill="#170B32" />
        <circle cx="136.166" cy="44.0339" r="2.01389" fill="#170B32" />
        <circle cx="154.326" cy="44.0339" r="2.01389" fill="#170B32" />
        <circle cx="172.49" cy="44.0339" r="2.01389" fill="#170B32" />
        <circle cx="190.655" cy="44.0339" r="2.01389" fill="#170B32" />
        <circle cx="208.819" cy="44.0339" r="2.01389" fill="#170B32" />
        <ellipse
          cx="226.983"
          cy="44.2856"
          rx="2.01389"
          ry="2.26562"
          fill="#170B32"
        />
        <circle cx="81.674" cy="64.5652" r="2.01389" fill="#170B32" />
        <circle cx="99.8381" cy="64.5652" r="2.01389" fill="#170B32" />
        <circle cx="117.998" cy="64.5652" r="2.01389" fill="#170B32" />
        <circle cx="136.166" cy="64.5652" r="2.01389" fill="#170B32" />
        <circle cx="154.326" cy="64.5652" r="2.01389" fill="#170B32" />
        <circle cx="172.49" cy="64.5652" r="2.01389" fill="#170B32" />
        <circle cx="190.655" cy="64.5652" r="2.01389" fill="#170B32" />
        <circle cx="208.819" cy="64.5652" r="2.01389" fill="#170B32" />
        <ellipse
          cx="226.983"
          cy="64.8169"
          rx="2.01389"
          ry="2.26562"
          fill="#170B32"
        />
        <circle cx="81.674" cy="85.0964" r="2.01389" fill="#170B32" />
        <circle cx="99.8381" cy="85.0964" r="2.01389" fill="#170B32" />
        <circle cx="117.998" cy="85.0964" r="2.01389" fill="#170B32" />
        <circle cx="136.166" cy="85.0964" r="2.01389" fill="#170B32" />
        <circle cx="154.326" cy="85.0964" r="2.01389" fill="#170B32" />
        <circle cx="172.49" cy="85.0964" r="2.01389" fill="#170B32" />
        <circle cx="190.655" cy="85.0964" r="2.01389" fill="#170B32" />
        <circle cx="208.819" cy="85.0964" r="2.01389" fill="#170B32" />
        <ellipse
          cx="226.983"
          cy="85.3481"
          rx="2.01389"
          ry="2.26562"
          fill="#170B32"
        />
        <circle cx="81.674" cy="105.628" r="2.01389" fill="#170B32" />
        <circle cx="99.8381" cy="105.628" r="2.01389" fill="#170B32" />
        <circle cx="117.998" cy="105.628" r="2.01389" fill="#170B32" />
        <circle cx="136.166" cy="105.628" r="2.01389" fill="#170B32" />
        <circle cx="154.326" cy="105.628" r="2.01389" fill="#170B32" />
        <circle cx="172.49" cy="105.628" r="2.01389" fill="#170B32" />
        <circle cx="190.655" cy="105.628" r="2.01389" fill="#170B32" />
        <circle cx="208.819" cy="105.628" r="2.01389" fill="#170B32" />
        <ellipse
          cx="226.983"
          cy="105.879"
          rx="2.01389"
          ry="2.26562"
          fill="#170B32"
        />
        <circle cx="81.674" cy="126.159" r="2.01389" fill="#170B32" />
        <circle cx="99.8381" cy="126.159" r="2.01389" fill="#170B32" />
        <circle cx="117.998" cy="126.159" r="2.01389" fill="#170B32" />
        <circle cx="136.166" cy="126.159" r="2.01389" fill="#170B32" />
        <circle cx="154.326" cy="126.159" r="2.01389" fill="#170B32" />
        <circle cx="172.49" cy="126.159" r="2.01389" fill="#170B32" />
        <circle cx="190.655" cy="126.159" r="2.01389" fill="#170B32" />
        <circle cx="208.819" cy="126.159" r="2.01389" fill="#170B32" />
        <ellipse
          cx="226.983"
          cy="126.411"
          rx="2.01389"
          ry="2.26562"
          fill="#170B32"
        />
        <circle cx="81.674" cy="146.69" r="2.01389" fill="#170B32" />
        <circle cx="99.8381" cy="146.69" r="2.01389" fill="#170B32" />
        <circle cx="117.998" cy="146.69" r="2.01389" fill="#170B32" />
        <circle cx="136.166" cy="146.69" r="2.01389" fill="#170B32" />
        <circle cx="154.326" cy="146.69" r="2.01389" fill="#170B32" />
        <circle cx="172.49" cy="146.69" r="2.01389" fill="#170B32" />
        <circle cx="190.655" cy="146.69" r="2.01389" fill="#170B32" />
        <circle cx="208.819" cy="146.69" r="2.01389" fill="#170B32" />
        <ellipse
          cx="226.983"
          cy="146.942"
          rx="2.01389"
          ry="2.26562"
          fill="#170B32"
        />
        <path
          d="M169 145.002L248 388.002L263 393.002L268.5 388.002L349 145.002H169Z"
          fill="url(#paint0_linear)"
        />
        <circle
          cx="154"
          cy="82.0024"
          r="18"
          stroke="#755BFF"
          strokeWidth="4"
        />
        <circle r="9" transform="matrix(-1 0 0 1 154 82.0024)" fill="#00FFA7" />
        <circle cx="259" cy="394.003" r="14" fill="#755BFF" />
        <circle
          cx="259"
          cy="394.003"
          r="28"
          stroke="#755BFF"
          strokeWidth="4"
        />
        <path
          d="M258.5 385.002V287.002C258.5 278.718 251.784 272.002 243.5 272.002H78C69.7157 272.002 63 265.287 63 257.002V224.502C63 216.218 69.7157 209.502 78 209.502H139.5C147.784 209.502 154.5 202.787 154.5 194.502V100.502"
          stroke="#755BFF"
          strokeWidth="4"
        />
        <line
          x1="201.117"
          y1="220.316"
          x2="181.318"
          y2="240.115"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="200.918"
          y1="240.115"
          x2="181.119"
          y2="220.316"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="116.117"
          y1="156.316"
          x2="96.3182"
          y2="176.115"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="115.918"
          y1="176.115"
          x2="96.1187"
          y2="156.316"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="247.117"
          y1="220.316"
          x2="227.318"
          y2="240.115"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="246.918"
          y1="240.115"
          x2="227.119"
          y2="220.316"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="33.1211"
          y1="296.316"
          x2="13.3221"
          y2="316.115"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="32.9216"
          y1="316.115"
          x2="13.1226"
          y2="296.316"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="33.1172"
          y1="248.316"
          x2="13.3182"
          y2="268.115"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="32.9177"
          y1="268.115"
          x2="13.1187"
          y2="248.316"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="79.1172"
          y1="296.316"
          x2="59.3182"
          y2="316.115"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="78.9177"
          y1="316.115"
          x2="59.1187"
          y2="296.316"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="129.117"
          y1="296.316"
          x2="109.318"
          y2="316.115"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <line
          x1="128.918"
          y1="316.115"
          x2="109.119"
          y2="296.316"
          stroke="#FF0A8E"
          strokeWidth="4"
          strokeLinecap="round"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="259"
            y1="401.502"
            x2="259"
            y2="145.002"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#001697" />
            <stop offset="1" stopColor="#001697" stopOpacity="0" />
          </linearGradient>
        </defs>
      </motion.svg>
    </div>
  )
}
